import {
    GET_DIALER_SETTINGS,
    GET_DIALER_PROFILE,
    GET_ALL_DIALER_PROFILES
} from '../constants/dialer.js';

export const initialState = {
    settings: {
        availableAccounts: 0
    },
    profile: {},
    allProfiles: {}
};

export function dialerReducer( state = initialState, action ) {

    switch ( action.type ) {

        case GET_DIALER_SETTINGS:

            return Object.assign( {}, state, {
                settings: action.settings
            });

        case GET_DIALER_PROFILE:

            return Object.assign( {}, state, {
                profile: action.profile
            });

        case GET_ALL_DIALER_PROFILES:

            return Object.assign( {}, state, {
                allProfiles: action.allProfiles
            });

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/dialer.js